import { Link, useNavigate } from 'react-router-dom';

export default function ServicesSection() {
  const navigate = useNavigate();

  const handleLeagueClick = () => {
    navigate('/winter-league');
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const services = [
    {
      icon: 'ri-building-line',
      title: 'Corporate Events',
      description: 'Team building activities and corporate entertainment with professional golf simulation.',
      image: 'https://public.readdy.ai/ai/img_res/44428e3ad93d2ef6c5514c861188f8ae.jpg'
    },
    {
      icon: 'ri-heart-line',
      title: 'Fundraisers',
      description: 'Engaging fundraising events with golf tournaments and contests to support your cause.',
      image: 'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/7148d608809782d1a62219571e22986f.jfif'
    },
    {
      icon: 'ri-cake-3-line',
      title: 'Birthday Parties',
      description: 'Memorable birthday celebrations with golf fun for all ages and skill levels.',
      image: 'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/4603edb6c835083fb2db62e0b92bfde4.jfif'
    },
    {
      icon: 'ri-community-line',
      title: 'Community Events',
      description: 'Community gatherings and neighborhood events with interactive golf entertainment.',
      image: 'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/71b6f2843f37dbf5c07cd2a8833fe1db.jpeg'
    },
    {
      icon: 'ri-group-line',
      title: 'Private Parties',
      description: 'Exclusive private events with personalized golf experiences for your guests.',
      image: 'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/95bbca6d85924639cbd6226004d6e4de.jpeg'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Special Events and League Play',
      description: 'Competitive tournaments with leaderboards, contests, and prizes.',
      image: 'https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/cdeb6c781bca524449185652bdf81387.png'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-green-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience golf like never before with our state-of-the-art mobile simulator
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const isLeague = service.title === 'Special Events and League Play';
            const CardWrapper = ({ children }: { children: React.ReactNode }) =>
              isLeague ? (
                <div onClick={handleLeagueClick} className="block cursor-pointer">
                  {children}
                </div>
              ) : (
                <>{children}</>
              );

            return (
              <CardWrapper key={index}>
                <div className={`bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 ${isLeague ? 'ring-2 ring-green-500 ring-offset-2' : ''}`}>
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-4 left-4 w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                      <i className={`${service.icon} text-white text-xl`}></i>
                    </div>
                    {isLeague && (
                      <div className="absolute bottom-4 right-4">
                        <span className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap">
                          <i className="ri-trophy-line mr-1"></i>
                          View Leagues
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{service.description}</p>
                  </div>
                </div>
              </CardWrapper>
            );
          })}
        </div>

        <div className="mt-16 bg-green-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Why Choose Great Golf On The Go?</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div>
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-green-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold mb-2">Mobile Setup</h4>
              <p className="text-green-100">We come to you with complete professional equipment</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-green-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold mb-2">Professional Service</h4>
              <p className="text-green-100">Experienced staff to ensure your event runs smoothly</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-settings-3-line text-green-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold mb-2">Customizable</h4>
              <p className="text-green-100">Tailored experiences to match your event needs</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
